import { faPenToSquare, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axiosInstance from '../config/axiosInstance'
import PaginationBar from '../components/common/PaginationBar';

function ServiceKeyList() {
  const [serviceKeyList, setServiceKeyList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    getServiceKeyList().then(r => {});
  }, []);

  let getServiceKeyList = async () => {
    try {
      const res = await axiosInstance.get("/service-key/get");
      setServiceKeyList(res.data?.data?.items ?? []);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  let handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm("Are you sure do you want to delete the data?");
      if (confirmDelete) {
        await axiosInstance.post(`/service-key/delete`, {
          id: id
        });
        await getServiceKeyList();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const filteredList = serviceKeyList.filter(config =>
    (filterText === "" || 
     config?.code.toLowerCase().includes(filterText.toLowerCase()) ||
     config?.name.toLowerCase().includes(filterText.toLowerCase()) ||
     config?.domain.toLowerCase().includes(filterText.toLowerCase()))
  );

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const maskKey = (key) => {
    if (!key) return "";
    if (key.length <= 8) return key;
    return key.slice(0, 4) + "****" + key.slice(-4);
  }

  return (
      <>
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Service Key List</h1>
          <div className="align-items-end">
            <Link to="/portal/create-service-key" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
              <FontAwesomeIcon icon={faPlus} className="create-service-key mr-2" />
              Create Service Key
            </Link>
          </div>
        </div>
        <div className="card shadow mb-4">
          <div className="card-body">
            <div className="row">
              <div className="mb-3 col-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Filter by Code, Name or Domain"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>

            {
              isLoading ? <img src='https://media.giphy.com/media/ZO9b1ntYVJmjZlsWlm/giphy.gif' alt="Loading" />
                  : <div className="table-responsive">
                    <nav>
                      <PaginationBar page={currentPage} totalPages={totalPages} totalItems={filteredList.length} onPageChange={paginate} />
                    </nav>
                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Code</th>
                          <th>Name</th>
                          <th>Domain</th>
                          <th>Key</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tfoot>
                        <tr>
                          <th>Id</th>
                          <th>Code</th>
                          <th>Name</th>
                          <th>Domain</th>
                          <th>Key</th>
                          <th>Action</th>
                        </tr>
                      </tfoot>
                      <tbody>
                      {currentItems.map((config) => {
                        const code = config?.code;
                        return (
                            <tr key={config.id}>
                              <td>{config.id}</td>
                              <td>{code}</td>
                              <td>{config?.name}</td>
                              <td>{config?.domain}</td>
                              <td>{maskKey(config?.key)}</td>
                              <th>
                                <Link to={`/portal/service-key-edit/${config.id}`} className='btn btn-outline-primary btn-sm mr-1'><FontAwesomeIcon icon={faPenToSquare} /> Edit</Link>
                                <button onClick={() => handleDelete(config.id)} className='btn btn-danger btn-sm mr-1'><FontAwesomeIcon icon={faTrash} /> Delete</button>
                              </th>
                            </tr>
                        )
                      })}
                      </tbody>
                    </table>
                    <nav>
                      <PaginationBar page={currentPage} totalPages={totalPages} totalItems={filteredList.length} onPageChange={paginate} />
                    </nav>
                  </div>
            }
          </div>
        </div>
      </>
  )
}

export default ServiceKeyList
